import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { buildApiUrl } from "../../config/api";
import BudgetAnalysis from "./budget-analysis";
import BudgetAnalysisIncome from "./budget-analysis-income";
import BudgetAnalysisExpenses from "./budget-analysis-expenses";
import BudgetAnalysisDebts from "./budget-analysis-debts";

const summaryComponents = {
  overview: BudgetAnalysis,
  income: BudgetAnalysisIncome,
  expenses: BudgetAnalysisExpenses,
  debts: BudgetAnalysisDebts,
};

const BudgetAnalysisSummaryThirdParty = ({
  section = "overview",
  token,
  clientId,
  params,
  client,
}) => {
  const [summaryData, setSummaryData] = useState(null);
  const [error, setError] = useState("");
  const SummaryComponent = summaryComponents[section] || BudgetAnalysis;

  useEffect(() => {
    const fetchSummary = async () => {
      setError("");
      const paramsQuery = params ? `?params=${encodeURIComponent(params)}` : "";
      const headers = { "Content-Type": "application/json" };
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      try {
        const response = await fetch(
          buildApiUrl(`api/get_budget_analysis_summary/${clientId}${paramsQuery}`),
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              API_key: process.env.REACT_APP_API_KEY,
              clientId,
            }),
          }
        );
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.error || data?.message || "Unable to load summary");
        }
        setSummaryData(data);
      } catch (requestError) {
        setError(requestError.message || "Unable to load summary");
      }
    };

    fetchSummary();
  }, [clientId, params, token]);

  if (error) {
    return <div className="text-center mt-250 text-danger">{error}</div>;
  }

  if (!summaryData) {
    return (
      <div className="d-flex justify-content-center mt-250">
        <ThreeDots height="40" width="80" radius="9" color="#4fa94d" visible />
      </div>
    );
  }

  return (
    <SummaryComponent
      thirdParty
      clientId={clientId}
      params={params}
      client={client}
      summaryData={summaryData}
    />
  );
};

export default BudgetAnalysisSummaryThirdParty;
